


































import { Component, Vue } from "vue-property-decorator";
import { domain, User, VueForm } from "@/domain";
import * as uiUtil from "@/uiUtil";
import QuickSnack from "@/components/QuickSnack.vue";

@Component({
  components: { QuickSnack }
})
export default class AccountDataPanel extends Vue {
  snackbar = "";
  isLoading = false;

  displayName = "";
  email = "";
  validUserData = true;

  get lang() {
    return this.$store.state.lang.data;
  }

  get currentUser(): User | null {
    return this.$store.state.currentUser;
  }

  created() {
    if (this.currentUser) {
      this.email = this.currentUser.fbUser.email || "";
      this.displayName = this.currentUser.fbUser.displayName || "";
    }
  }

  async cmdSaveUserData() {
    if ((this.$refs.userDataForm as VueForm).validate()) {
      this.isLoading = true;
      const profile = { displayName: this.displayName };
      try {
        await domain.backend.changeUserData(profile);
        this.snackbar = this.lang.profileUpdated;
        this.$store.commit("updateProfile", profile);
      } catch (err) {
        this.snackbar = uiUtil.toErrorMsg(err as Error, this.lang.errorChangePassword);
      }
      this.isLoading = false;
    }
  }
}
